import { API_CALL_FAILURE, API_CALL_REQUEST, API_CALL_SUCCESS } from 'actions/actionConstants'
import { FETCH_MERCHANDISE_ADVERTS } from 'actions/apiActionConstants'
import { createReducer, reducerSwitch } from 'lib/redux/reducerUtils'

export const INITIAL_MERCHANDISE_STATE: App.MerchandiseState = {
  advertCatalogue: {
    initial: true,
    fetching: undefined,
    error: undefined,
  },
}

const apiRequests = reducerSwitch<App.MerchandiseState>({
  [FETCH_MERCHANDISE_ADVERTS]: () => ({
    advertCatalogue: {
      fetching: true as const,
      error: undefined,
    },
  }),
})

const apiSuccesses = reducerSwitch<App.MerchandiseState>({
  [FETCH_MERCHANDISE_ADVERTS]: (_state, action) => ({
    advertCatalogue: {
      data: { advertItems: action.data.advertItems },
      fetching: false,
      error: undefined,
    },
  }),
})

const apiFailures = reducerSwitch<App.MerchandiseState>({
  [FETCH_MERCHANDISE_ADVERTS]: (_state, action) => ({
    advertCatalogue: {
      fetching: false as const,
      error: action.error,
    },
  }),
})

export default createReducer<App.MerchandiseState>(INITIAL_MERCHANDISE_STATE, {
  [API_CALL_REQUEST]: (state, action) => apiRequests(action.api)(state, action),
  [API_CALL_FAILURE]: (state, action) => apiFailures(action.api)(state, action),
  [API_CALL_SUCCESS]: (state, action) => apiSuccesses(action.api)(state, action),
})
